import OrganizationService from "../../service/OrganizationService";

export const namespaced = true;

export const state = {
  organizations: [
    {
      id: "3",
      name: "Help Nigeria Group",
      image: "",
      website: "",
      rubiesAccount: ""
    },
    {
      id: "1",
      name: "Crown Gold Foundation",
      image: "",
      website: "",
      settlementAccount: "1899021532",
      settlementAccountName: "Givers Arena(Adex Adebukola Crowngold Foundation)"
    },
    {
      id: "2",
      name: "Initiative for Adequate Nutrition (IFAN)",
      image:
        "https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/donate.rubies.com/IFAN.jpg",
      website: "",
      settlementAccount: "4028894908",
      settlementAccountName: "INITIATIVE FOR ADEQUATE NUTRITION"
    },
    {
      id: "4",
      name: "Pistis Foundation",
      image:
        "https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/donate.rubies.com/pistis-foundation.png",
      website: "",
      rubiesAccount: ""
    },
    {
      id: "5",
      name: "COVID-19 Global Emergency Fund SME",
      image: "",
      website: "",
      rubiesAccount: ""
    },
    {
      id: "6",
      name: "Lagos Coral Jaycees",
      image: "",
      website: "",
      rubiesAccount: ""
    },
    {
      id: "7",
      name: "Demi care Foundation (NGO)",
      image: "",
      website: "",
      rubiesAccount: ""
    },
    {
      id: "8",
      name: "Tabitha Cumi Foundation",
      image:
        "https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/donate.rubies.com/tabitha-cumi-foundation.png",
      website: "",
      rubiesAccount: ""
    },
    {
      id: "9",
      name: "SIAF COVID19 Food Fund",
      image: "",
      website: "",
      rubiesAccount: ""
    }
  ],
  organizationsMini: [
    {
      id: "1",
      name: "Help Nigeria Group",
      image: "",
      website: "",
      rubiesAccount: ""
    },
    {
      id: "2",
      name: "Crown Gold Foundation",
      image: "",
      website: "",
      rubiesAccount: "1899021532"
    },
    {
      id: "3",
      name: "Initiative for Adequate Nutrition (IFAN)",
      image: "",
      website: "",
      rubiesAccount: "4028894908"
    },
    {
      id: "4",
      name: "Pistis Foundation",
      image:
        "https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/donate.rubies.com/pistis-foundation.png",
      website: "",
      rubiesAccount: ""
    },
    {
      id: "5",
      name: "COVID-19 Global Emergency Fund SME",
      image: "",
      website: "",
      rubiesAccount: ""
    },
    {
      id: "6",
      name: "Lagos Coral Jaycees",
      image: "",
      website: "",
      rubiesAccount: ""
    }
  ]
};

export const getters = {
  getOrganizationsOptions(state) {
    const allOrganizations = state.organizations;
    return allOrganizations.map(organization => organization.name);
  },
  getOrganizationIdFromOption: state => chosenOption => {
    const allOrganizations = state.organizations;

    let opt = allOrganizations.filter(function(organization) {
      return organization.name === chosenOption;
    });

    return opt[0].id;
  },
  getOrganizationNameFromId: state => chosenOption => {
    const allOrganizations = state.organizations;

    let opt = allOrganizations.filter(function(organization) {
      return organization.id === chosenOption;
    });

    return opt[0].name;
  }
};

export const mutations = {
  SET_ORGANIZATION(state, payload) {
    state.organizations = payload;
  },
  SET_ORGANIZATION_MINI(state, payload) {
    state.organizationsMini = payload;
  }
};
export const actions = {
  getAllOrganizations({ commit, dispatch }, payload) {
    return OrganizationService.getAllOrganizations(payload)
      .then(response => {
        let responseData = response.data;
        if (responseData.responsecode === "00") {
          commit("SET_ORGANIZATION", responseData.organizations);
          commit(
            "SET_ORGANIZATION_MINI",
            responseData.organizations.slice(0, 3)
          );
        }
      })
      .catch(error => {
        let notification = {
          type: "error",
          message: `Error -> ${error}`
        };
        dispatch("notification/add", notification, { root: true });
        throw error;
      });
  }
};
